const baseTestId = 'test-id-';
export default {
  PRIVACY: {
    PAGE_WRAPPER: baseTestId + 'privacyPageWrapper',
  },
  TERMS: {
    PAGE_WRAPPER: baseTestId + 'termsPageWrapper',
  },
  COMMON: {
    ADD_EXTENSION_BUTTON: baseTestId + 'commonAddExtensionButton',
    SEARCH_FIELD: baseTestId + 'commonSearchField',
    MEAL_COUNTER: baseTestId + 'commonMealCounter',
    SEARCH_FIELD_APPEND: baseTestId + 'commonSearchFieldAppend',
    SEARCH_FIELD_SUGGESTIONS: baseTestId + 'commonSearchFieldSuggestions',
  },
  HEADER: {
    HOME: baseTestId + 'headerNavHome',
    ABOUT: baseTestId + 'headerNavAbout',
    HOW_IT_WORKS: baseTestId + 'headerNavHowItWorks',
    DONATION: baseTestId + 'headerNavDonation',
    SIGN_UP: baseTestId + 'headerNavSignUp',
    LOG_OUT: baseTestId + 'headerNavLogOut',
    ANIMALS_HELPED: baseTestId + 'headerAnimalsHelped',
    POINTS_INDICATOR: baseTestId + 'headerPointsIndicator',
    POINTS_INDICATOR_HANDLER: baseTestId + 'headerPointsIndicatorHandler',
    DELETE_ACCOUNT: baseTestId + 'headerDeleteAccount',
  },
  FOOTER: {
    ABOUT: baseTestId + 'footerNavAbout',
    HOW_IT_WORKS: baseTestId + 'footerNavHowItWorks',
    DONATION: baseTestId + 'footerNavDonation',
    PRIVACY: baseTestId + 'footerNavPrivacy',
    TERMS: baseTestId + 'footerNavTerms',
    IOS_BUTTON: baseTestId + 'footerIOSButton',
    ANDROID_BUTTON: baseTestId + 'footerAndroidButton',
    deleteAccount: baseTestId + 'footerDeleteAccount',
  },
  SIGN_UP: {
    INPUT: baseTestId + 'signupInput',
  },
  HOME: {
    HEADER: baseTestId + 'homeHeader',
    CHARITIES_IMG: baseTestId + 'homeCharitiesImg',
    SCROLL_TRIGGER_BTN: baseTestId + 'homeScrollTriggerBtn',
    CAROUSEL_IMAGE: baseTestId + 'homeCarouselImage',
    CAROUSEL_TEXT: baseTestId + 'homeCarouselText',
    CAROUSEL_BUTTON: baseTestId + 'homeCarouselButton',
    BUBBLE_IMAGE_1: baseTestId + 'homeBubbleImage1',
    BUBBLE_IMAGE_2: baseTestId + 'homeBubbleImage2',
    BUBBLE_IMAGE_3: baseTestId + 'homeBubbleImage3',
    BUBBLE_IMAGE_4: baseTestId + 'homeBubbleImage4',
    BUBBLE_ADD_EXTENSION_BUTTON: baseTestId + 'homeBubbleAddExtensionButton',
  },
  ABOUT: {
    OUR_STORY: baseTestId + 'aboutOurStory',
  },
  DONATION: {
    SPONSORED_PETS: baseTestId + 'donationSponsoredPets',
  },
  SEARCH: {
    PAGE_WRAPPER: baseTestId + 'searchPageWrapper',
  },
};
